<template>
  <div>
    <button
      class="tag"
      :class="{
        'active': active,
        'primary': closeable,
      }"
      @click.prevent="e => $emit('select', e)">
      {{ label }}
      <svg v-if="active && !closeable" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
      <svg v-else-if="closeable" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Tag',
  props: {
    label: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    closeable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.tag {
  height: 33px;
  font-size: 15px;
  padding: 0 14px;
  transition: all 0.15s ease-out;
  background-color: transparent;
  display: inline-flex;
  align-items: center;
  border: 1px solid transparent;
  cursor: pointer;
  border-radius: 16px;
  outline: 0;
  margin-bottom: 10px;
  white-space: nowrap;

  &:hover, &:focus {
    border-color: rgba(black, 0.25);

    &:active {
      background-color: rgba(black, 0.25);
    }
  }

  &.active {
    background-color: white;
    border-color: #fff;
    padding-right: 10px;

    &:hover, &:focus {
      border-color: #fff;
    }
  }

  .icon {
    width: 13px;
    height: 9px;
    margin-left: 2px;
    pointer-events: none;
  }

  .icon--close {
    width: 10px;
    height: 10px;
  }

  &.primary {
    border-color: #e4decf;

    &:hover, &:focus {
      border-color: #c6ba99;
    }
  }
}

.tag-row {
  display: flex;
  flex-wrap: wrap;
}

.tag-wrap {
  flex: 0 0 50%;
}
</style>
